import type { CSSProperties } from "react";
import { cn } from "@/lib/utils";

interface PlaceholderCardProps {
	className?: string;
	style?: CSSProperties;
}

/** Shimmering skeleton block used for image/product placeholders in mock UIs. */
function PlaceholderCard(prop: PlaceholderCardProps) {
	const { className, style } = prop;
	return <div className={cn("jana-shimmer", className)} style={style} aria-hidden />;
}

export default PlaceholderCard;
